export const CRITICAL_ACTIVE = "CRITICAL_ACTIVE";
export const NON_EFFECTIVE_ACTIVE = "NON_EFFECTIVE_ACTIVE";
export const TOGGLE_DIAGRAM = "TOGGLE_DIAGRAM";